"use client"

import Image from "next/image"

export default function CourseContent() {
  const contentItems = [
    {
      icon: "/course/live-session-icon.webp",
      title: "Live sessions with hands-on Python Notebooks",
    },
    {
      icon: "/course/feedback-circle.webp",
      title: "Q&A and feedback with the instructor",
    },
    {
      icon: "/course/life-time-access-circle.webp",
      title: "Lifetime access to course content and recordings",
    },
    {
      icon: "/course/certificate-circile.webp",
      title: "Certificate of completion",
    },
  ]

  return (
    <section className="py-16 lg:py-20 bg-gray-950">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-montserrat font-bold text-white mb-4">Course Content</h2>
          <div className="w-24 h-1 bg-green-500 mx-auto"></div>
        </div>

        <div className="space-y-12">
          {contentItems.map((item, index) => (
            <div key={index} className="flex flex-col items-center text-center gap-4">
              <div className="w-20 h-20 rounded-full border-2 border-white flex items-center justify-center flex-shrink-0 text-white bg-gray-900">
                <Image src={item.icon || "/placeholder.svg"} alt="" width={32} height={32} className="w-8 h-8" />
              </div>
              <div>
                <h3 className="text-xl font-vietnam font-medium text-white">{item.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
